import { t } from '@/i18n'

export interface ModelType {
  name: string
  taskInfoExpanded: {
    key: string
    value:
      | string
      | {
          id: string
          name: string
        }
      | {
          device_ip: string
          device_brand: string
        }
      | { [key: string]: string | number }
      | string[]
      | { value: string | number; type: string; default?: string }[]
    type: string
    deepType?:
      | {
          id: string
          name: string
        }
      | { device_ip: string; device_brand: string }
  }[]
  taskInfo: {
    key: string
    value:
      | string
      | {
          id: string
          name: string
        }[]
      | { [key: string]: string | number }
      | string[]
      | { value: string | number; type: string; default?: string }[]
    type: string
  }[]
}

export const displayModel = {
  name: 'WG',
  taskInfoExpanded: [
    {
      key: t('安全域'),
      value: 'bizAreaName',
      type: 'string',
    },
    {
      key: t('任务ID'),
      value: 'task_id',
      type: 'string',
    },
    {
      key: t('客户端'),
      value: 'hostname',
      type: 'string',
    },
    {
      key: t('执行类型'),
      value: [
        {
          value: 'schedulerType',
          type: 'number',
          default: t('立即'),
        },
        {
          value: 'task_time_list',
          type: 'array',
          deepType: {
            item: 'string',
          },
        },
      ],
    },
    {
      key: t('任务模板'),
      value: 'templateNameList',
      type: 'array',
    },
    {
      key: t('安全设备'),
      value: 'devices',
      type: 'array',
    },
  ],
  taskInfo: [
    {
      key: t('安全域'),
      value: 'bizAreaName',
      type: 'string',
    },
    {
      key: t('客户端'),
      value: 'agentName',
      type: 'string',
    },
    {
      key: t('进度信息'),
      value: [
        {
          value: 'isFinished',
          type: 'number',
        },
        {
          value: 'progressRate',
          type: 'number',
        },
        {
          value: 'executeSuccessCount',
          type: 'number',
        },
        {
          value: 'execute_fail_count',
          type: 'number',
        },
      ],
    },
  ],
} as ModelType

export interface PluginDetailProps {
  id: string
  plugin_name: string
  supported_architectures: string[]
  supported_platforms: string[]
  params: {
    key: string
    value: string
    type: string
    description: string
  }[]
  tactic_list: { name: string; url: string }[]
  intercept_status: number
  risk_level: number
  attack_type: number
  attack_name: string
  describe: string
  solution: string
  apt_list: string[]
  update_time: string
  device_security: any[]
  plugin_log: any
  samples_list: { id: string; samples_name: string; samples_path: string; samples_sha256: string }[]
  principle: string
  start_time: string
  end_time: string
  resource_tag_list: V1TagCategory[]
  intercept_from: string
}

export interface V1TagCategory {
  tagCategoryName?: string
  tagName?: string[]
  [property: string]: any
}
